import React from "react";
import PragatiPipelineLogo from "./../../assets/pragati-pipeline-with-shadow.svg";

export const PragatiPipeline = ({
  className,
  title,
  isValidProject,
  prgaticss
}) => {
  return isValidProject || prgaticss ? (
    <div className={className}>
      <img src={PragatiPipelineLogo} />
    </div>
  ) : null;
};
